import React from 'react'
import { Text } from 'rebass'
import citygateTheme from '../../theme/'
import LinkRounded from '../LinkRounded'
import ContentVehicleMultiCardListing from '../ContentVehicleMultiCardListing'
import { Container } from '../../utils/style'

const buildFilter = ({ make, model }) => {
  let filter = ''
  if (make || model) filter = '?'
  if (make) {
    filter += `brand=${make}&`
  }
  if (model) {
    filter += `model=${model}&`
  }
  return filter.replace(/&$/, '').toLowerCase()
}

const UsedVehicleSelection = ({ usedVehicles, make, model }) => {
  usedVehicles = usedVehicles.filter((v) => !v.expiredDate)
  return (
    <section>
      <ContentVehicleMultiCardListing
        vehicles={usedVehicles}
        heading={'Used cars currently in stock'}
        max={4}
        loop
        withMake
        justPrice
        buttons={false}
      />

      <Container
        maxWidth={citygateTheme.content.max.width}
        pt={0}
        pb={[80, null, 120]}
      >
        <Text center as="div">
          <LinkRounded to={'/cars/used' + buildFilter({ make, model })} shadow>
            View all used {model && model}
          </LinkRounded>
        </Text>
      </Container>
    </section>
  )
}

export default UsedVehicleSelection
